// File upload statuses:
export const UPLOAD_RUNNING = 0;
export const UPLOAD_FINISHED = 1;
